// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import BannerCropperController from "./banner_cropper_controller"
application.register("banner-cropper", BannerCropperController)

import BibleReaderController from "./bible_reader_controller"
application.register("bible-reader", BibleReaderController)

import BroadcastDedupController from "./broadcast_dedup_controller"
application.register("broadcast-dedup", BroadcastDedupController)

import CalendarSwipeController from "./calendar_swipe_controller"
application.register("calendar-swipe", CalendarSwipeController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import DeclarativeWebPushDebugController from "./declarative_web_push_debug_controller"
application.register("declarative-web-push-debug", DeclarativeWebPushDebugController)

import FirebaseDebugController from "./firebase_debug_controller"
application.register("firebase-debug", FirebaseDebugController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InteractPaneController from "./interact_pane_controller"
application.register("interact-pane", InteractPaneController)

import MetricsController from "./metrics_controller"
application.register("metrics", MetricsController)

import NotificationCleanseController from "./notification_cleanse_controller"
application.register("notification-cleanse", NotificationCleanseController)

import NotificationPermissionController from "./notification_permission_controller"
application.register("notification-permission", NotificationPermissionController)

import NotificationPreferencesController from "./notification_preferences_controller"
application.register("notification-preferences", NotificationPreferencesController)

import PrayerSessionTimerController from "./prayer_session_timer_controller"
application.register("prayer-session-timer", PrayerSessionTimerController)

import ProfilePictureCropperController from "./profile_picture_cropper_controller"
application.register("profile-picture-cropper", ProfilePictureCropperController)

import PwaAwareController from "./pwa_aware_controller"
application.register("pwa-aware", PwaAwareController)

import PwaInstallationInstructionsController from "./pwa_installation_instructions_controller"
application.register("pwa-installation-instructions", PwaInstallationInstructionsController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import ScriptureDigController from "./scripture_dig_controller"
application.register("scripture-dig", ScriptureDigController)

import SortController from "./sort_controller"
application.register("sort", SortController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import TechTreeController from "./tech_tree_controller"
application.register("tech-tree", TechTreeController)

import TimeTrackerController from "./time_tracker_controller"
application.register("time-tracker", TimeTrackerController)

import ToolPlacementDetailController from "./tool_placement_detail_controller"
application.register("tool-placement-detail", ToolPlacementDetailController)

import UserActionsLogsFilterController from "./user_actions_logs_filter_controller"
application.register("user-actions-logs-filter", UserActionsLogsFilterController)
